import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastController } from '@ionic/angular';
import { AuthProvider } from 'src/app/providers/auth.provider';
import { ProfileHelperService } from 'src/app/providers/profile-helper/profile-helper.service';
import { UserData } from 'src/app/providers/user-data';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.page.html',
  styleUrls: ['./forgot-password.page.scss'],
})
export class ForgotPasswordPage {

  login: any = { email: ''};
  submitted = false;
  error = '';
  version = "1.0";
  serverEnv = "Dev"
  // serverEnv = "Production"

  constructor(
    public userData: UserData,
    public router: Router,
    private authProvider: AuthProvider,
    public toastCtrl: ToastController,
    // private oneSignal: OneSignal,
    private profileHelper: ProfileHelperService
 
  ) { 
  }

  async sendEmail(form: NgForm) {
    this.submitted = true;
    this.error = '';
    if (form.valid) {
      // this.router.navigateByUrl('/login');
      try {
        await this.authProvider.startLoading();
        const tempRes = await this.authProvider.forgotPasswordApi(form.value);
        await this.toastCtrl.create({
          message: 'E-mail weryfikacyjny został wysłany.',
          duration: 3000,
          position: 'bottom',
        });
        await this.authProvider.closeLoading()
        this.login = { email: ''};
      } catch (error) {
        console.log("err ", error);
        this.error = error;
        await this.toastCtrl.create({
          message: error.message,
          duration: 3000,
          position: 'bottom',
        });
        await this.authProvider.closeLoading()
      }
      this.submitted = false;
    }
  }

  printIt () {
    console.log('hello');
  }

  loginPage() {
    this.router.navigateByUrl('/login');
  }

  forgotPassword() {
    this.router.navigateByUrl('/forgot-password');
  }


}
